import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { svgIconStyles as n } from "../svg-icon/SvgIcon.styles.js";
function a({
  label: C,
  className: o,
  size: i,
  ...t
}) {
  return /* @__PURE__ */ l(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "favoriteOutline",
      stroke: "none",
      role: "img",
      "aria-hidden": !C,
      focusable: "false",
      className: n({ className: o, size: i }),
      ...t,
      children: [
        C && /* @__PURE__ */ e("title", { children: C }),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.9989 5.06214C11.9648 5.03028 11.9296 4.9978 11.8935 4.96479C11.3664 4.48355 10.6059 3.86902 9.69781 3.37508C8.79405 2.8835 7.68765 2.4807 6.48778 2.50072C5.25664 2.52125 4.01121 2.9867 2.87777 4.08646C0.565283 6.33021 0.521004 9.85296 2.02335 13.0649C3.54114 16.3098 6.70075 19.4637 11.252 21.3516C11.7289 21.5495 12.2689 21.5495 12.7458 21.3516C17.2971 19.4637 20.4567 16.3098 21.9745 13.0649C23.4768 9.85295 23.4325 6.33021 21.12 4.08646C19.9866 2.9867 18.7412 2.52125 17.51 2.50072C16.3102 2.4807 15.2038 2.8835 14.3 3.37508C13.3919 3.86902 12.6315 4.48355 12.1043 4.96479C12.0682 4.9978 12.033 5.03028 11.9989 5.06214ZM12.7586 7.14604L12.759 7.14554L12.7644 7.13937C12.7704 7.13241 12.7807 7.12072 12.795 7.10473C12.8237 7.07273 12.8685 7.02362 12.928 6.96086C13.0473 6.83511 13.2248 6.65587 13.4499 6.4503C13.9045 6.03524 14.5328 5.5321 15.2527 5.14052C15.977 4.74658 16.7379 4.49601 17.4768 4.50834C18.1845 4.52014 18.9494 4.77273 19.7301 5.53026C21.1936 6.95021 21.4638 9.43279 20.1641 12.2114C18.8816 14.9534 16.1284 17.7714 11.9989 19.4889C7.86938 17.7714 5.11619 14.9534 3.83369 12.2114C2.53401 9.43279 2.80421 6.95021 4.26766 5.53026C5.0484 4.77273 5.81332 4.52014 6.521 4.50834C7.25995 4.49601 8.02082 4.74658 8.74507 5.14052C9.46499 5.5321 10.0933 6.03524 10.5479 6.4503C10.773 6.65587 10.9505 6.83511 11.0698 6.96086C11.1293 7.02362 11.1741 7.07273 11.2028 7.10473C11.2171 7.12072 11.2274 7.13241 11.2334 7.13937L11.2388 7.14554L11.2392 7.14604L11.2394 7.14618L11.2395 7.1464C11.2396 7.14641 11.2396 7.14642 11.2396 7.14644C11.2397 7.14656 11.2398 7.14668 11.2399 7.14679C11.4298 7.36913 11.7071 7.49711 11.9989 7.49711C12.2911 7.49711 12.5686 7.36884 12.7586 7.14604Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  a as FavoriteOutlineIcon,
  a as default
};
